import { defineMessages } from "react-intl";

const PERSONAL_DATA_SETTINGS = "personal-data-settings";

const personalDataSettingsMessages = defineMessages({
  sectionTitle: {
    id: `${PERSONAL_DATA_SETTINGS}.section-title`,
    defaultMessage: `Personal data settings`
  },
  sectionTitleWithFlag: {
    id: `${PERSONAL_DATA_SETTINGS}.section-title-with-flag`,
    defaultMessage: `Data Privacy Settings`
  },
  sectionDescription: {
    id: `${PERSONAL_DATA_SETTINGS}.section-description`,
    defaultMessage: `Use the settings below to control what EBSCO can do with your personal data.`
  },
  sectionDescriptionWithFlag: {
    id: `${PERSONAL_DATA_SETTINGS}.section-description-with-flag`,
    defaultMessage: `Use the settings below to manage your MyEBSCO account data.`
  }
});

export default personalDataSettingsMessages;
